import React, { useState } from "react";

const faqs = [
    {
        question: "What courses does SSS Achievers offer?",
        answer:
            "We offer offline coaching for school foundation (6th to 12th) and competitive exams like SSC, Banking, and other government job exams.",
    },
    {
        question: "Is there a free demo class available?",
        answer:
            "Yes, we offer a completely free demo class so students can experience our teaching before enrolling.",
    },
    {
        question: "Are classes conducted online or offline?",
        answer:
            "SSS Achievers is an offline coaching institute. All classes are held at our physical campus with personal attention.",
    },
    {
        question: "Do you provide study material and tests?",
        answer:
            "Yes, we provide regularly updated study material and conduct weekly and monthly tests for consistent performance tracking.",
    },
    {
        question: "How can I enroll or contact for admission?",
        answer:
            "You can visit our campus directly or call us at the contact number provided on the website to inquire about admissions.",
    },
];

const FAQSection = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <section className="px-6 py-16 bg-gray-50 text-gray-800">
            <div className="max-w-4xl mx-auto">
                <h2 className="text-3xl font-bold text-center mb-10">Frequently Asked Questions</h2>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div key={index} className="border border-gray-200 rounded-md shadow-sm">
                            <button
                                className="w-full text-left p-4 font-medium focus:outline-none flex justify-between items-center"
                                onClick={() => toggleFAQ(index)}
                            >
                                <span>{faq.question}</span>
                                <span>{openIndex === index ? "−" : "+"}</span>
                            </button>
                            {openIndex === index && (
                                <div className="px-4 pb-4 text-sm text-gray-600">{faq.answer}</div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FAQSection;
